import React from 'react'
import { Scanner } from '@yudiel/react-qr-scanner'
import useViewModel from './ViewModel'
import Table from 'react-bootstrap/Table'
import { Badge, Button } from 'react-bootstrap'
import Form from 'react-bootstrap/Form'
import { Link } from 'react-router-dom'
import moment from 'moment'
import { KTSVG } from '../../../../_metronic/helpers'
import clsx from 'clsx'
import Switch from 'react-switch'
import PileExecutionAttachmentView from '../PileExecutionAttachment/View'
import Select from 'react-select'

const ProjectPileExecutionView: React.FC = () => {
  const {
    isSubmitting,
    projectMachineOptions,
    projectState,
    inventorySelected,
    selected,
    projectId,
    startScan,
    manualScanInput,
    scannedData,
    pileHole,
    setStartScan,
    hasCamera,
    isUseCamera,
    toggleUseCamera,
    showAddButtonAttachmentDrivedPile,
    handleScan,
    handleManualScan,
    handleRemoveScanned,
    handleInputCodeChange,
    handleCancelSelected,
    handlePileDriving,
    handlePileClose,
    handleExecutedPileAttachment,
    onOpenproject,
    onCloseproject,
    additionalFormState,
    onChangeAdditionalFormState,
  } = useViewModel()

  const mappingStatus: Record<string, string> = {
    received: 'พร้อมใช้งาน',
    'pile-driving': 'กำลังตอก',
    done: 'ตอกสำเร็จ',
  }

  return (
    <React.Fragment>
      <PileExecutionAttachmentView />

      <div className='row gy-5 mb-5'>
        <div className='col-12'>
          <div className='card'>
            <div className='card-header'>
              <div className='card-title'>Scan QR Code</div>
              <div className='card-toolbar'>
                {projectState === 'pending' && (
                  <button onClick={onOpenproject} className='btn btn-success me-2 mb-2'>
                    เปิดโครงการ
                  </button>
                )}
                {projectState === 'in-progress' && (
                  <button onClick={onCloseproject} className='btn btn-danger me-2 mb-2'>
                    ปิดโครงการ
                  </button>
                )}

                {pileHole?.status !== 'completed' && (
                  <button
                    className='btn btn-sm btn-primary me-2 mb-2'
                    onClick={() => {
                      setStartScan(!startScan)
                    }}>
                    <KTSVG
                      path='/media/icons/duotune/arrows/arr075.svg'
                      svgClassName='svg-icon-1x svg-primary'
                    />
                    <span>เริ่มตอกเสาเข็ม</span>
                  </button>
                )}

                <Link to={`/project/${projectId}/pile-executed-list`}>
                  <button className='btn btn-sm btn-primary mb-2'>
                    <KTSVG
                      path='/media/icons/duotune/arrows/arr017.svg'
                      svgClassName='svg-icon-1 svg-primary'
                    />
                    <span>รายการหลุม</span>
                  </button>
                </Link>
              </div>
            </div>

            <div className='card-body'>
              {startScan && (
                <div className='row'>
                  <div className='col-6'>
                    <label>
                      <span style={{ marginRight: 20 }}>ใช้งานกล้อง</span>
                      <Switch onChange={toggleUseCamera} checked={isUseCamera} />
                    </label>
                  </div>
                </div>
              )}
              {startScan && hasCamera && isUseCamera && (
                <Scanner
                  // facingMode='environment'
                  // delay={1000}
                  onScan={handleScan}
                  constraints={{ facingMode: 'environment' }}
                />
              )}
              {startScan && !isUseCamera && (
                <form
                  className='row'
                  onSubmit={(e: React.FormEvent) => {
                    e.preventDefault()
                    handleManualScan()
                  }}>
                  <div className='separator separator-dashed my-6'></div>
                  <div className='fs-6 fw-bolder mb-1'>ระบุรหัส Barcode</div>
                  <div className='col-xl-3'>
                    <Form.Control
                      type='text'
                      id='manualInput'
                      value={manualScanInput}
                      onChange={handleInputCodeChange}
                      disabled={isSubmitting}
                    />
                  </div>
                  <div className='col d-flex mt-5 mt-lg-0'>
                    <Button disabled={isSubmitting} variant='primary' type='submit'>
                      <KTSVG
                        path='/media/icons/duotune/files/fil009.svg'
                        className='svg-icon-2x svg-primary'
                      />
                      ยืนยัน
                    </Button>
                  </div>
                </form>
              )}
              {/* <p>{data}</p> */}
              {inventorySelected && (
                <Table striped bordered hover>
                  <tbody>
                    <tr>
                      <td>ชื่อเสา</td>
                      <td>
                        <p>{inventorySelected.pileTitle}</p>
                        <p>{inventorySelected.pileCode}</p>
                      </td>
                    </tr>
                    <tr>
                      <td>สถานะ</td>
                      <td>
                        <Badge
                          bg={inventorySelected.usageStatus === 'done' ? 'success' : 'primary'}>
                          {mappingStatus[inventorySelected.usageStatus] ??
                            inventorySelected.usageStatus}
                        </Badge>
                      </td>
                    </tr>
                    <tr>
                      <td>ตอกโดยเครื่องจักร</td>
                      <td>
                        <Select
                          isDisabled={isSubmitting}
                          id='projectMachineId'
                          options={projectMachineOptions}
                          value={
                            projectMachineOptions.find(
                              o => o.value === additionalFormState.projectMachineId
                            ) ?? null
                          }
                          onChange={(selectedOption: any) => {
                            onChangeAdditionalFormState('projectMachineId', selectedOption?.value)
                          }}
                          styles={{
                            control: (provided: any) => ({
                              ...provided,
                              minHeight: 0,
                              fontSize: '0.95rem',
                              border: '1px solid #e1e3ea',
                            }),
                          }}
                        />
                      </td>
                    </tr>
                    <tr>
                      <td>Pile No.</td>
                      <td>
                        <input
                          disabled={isSubmitting}
                          type='text'
                          className='form-control form-control-sm'
                          value={additionalFormState.pileNo ?? ''}
                          onChange={(e: any) =>
                            onChangeAdditionalFormState('pileNo', e.target.value)
                          }
                        />
                      </td>
                    </tr>
                    <tr>
                      <td>Grid Line</td>
                      <td>
                        <input
                          disabled={isSubmitting}
                          type='text'
                          className='form-control form-control-sm'
                          value={additionalFormState.gridLine ?? ''}
                          onChange={(e: any) =>
                            onChangeAdditionalFormState('gridLine', e.target.value)
                          }
                        />
                      </td>
                    </tr>
                    <tr>
                      <td>สถานที่</td>
                      <td>
                        <input
                          disabled={isSubmitting}
                          type='text'
                          className='form-control form-control-sm'
                          value={additionalFormState.location ?? ''}
                          onChange={(e: any) =>
                            onChangeAdditionalFormState('location', e.target.value)
                          }
                        />
                      </td>
                    </tr>
                  </tbody>
                </Table>
              )}
            </div>
          </div>
        </div>

        {/* Confirm Exec pile action */}
        {inventorySelected && (
          <div className='col-12'>
            <div className='text-center my-3 d-flex justify-content-between'>
              <Button
                disabled={isSubmitting}
                variant='danger'
                className='mx-3'
                onClick={() => {
                  handleCancelSelected()
                }}>
                ยกเลิก
              </Button>
              {inventorySelected.usageStatus === 'received' && (
                <Button
                  disabled={isSubmitting}
                  variant='success'
                  className='mx-3'
                  onClick={() => {
                    handlePileDriving()
                  }}>
                  ยืนยันการตอก
                </Button>
              )}
            </div>
          </div>
        )}
        {/* END Confirm Exec pile action */}

        {pileHole && (
          <div className='col-12'>
            <div className='card'>
              <div className='card-body'>
                <h3>
                  หลุมที่ {pileHole.seq} {pileHole.status}
                </h3>

                <div className='table-responsive'>
                  {/* begin::Table */}
                  <table className='table table-row-bordered table-row-gray-100 align-middle gs-0 gy-3'>
                    {/* begin::Table head */}
                    <thead>
                      <tr>
                        <th className='p-0 w-50px'></th>
                        <th className='p-0 min-w-150px'></th>

                        <th className='p-0 min-w-125px'></th>
                        <th className='p-0 min-w-40px'></th>
                      </tr>
                    </thead>
                    {/* end::Table head */}
                    {/* begin::Table body */}
                    <tbody>
                      {pileHole.itemInventory.map((item: any, index: number) => (
                        <tr key={index + 'pileHole'}>
                          <td>
                            <div className='symbol symbol-50px me-2'>
                              <span className='symbol-label'>
                                <KTSVG
                                  path='/media/icons/duotune/general/gen002.svg'
                                  className='svg-icon-1 svg-icon-2hx'
                                />
                              </span>
                            </div>
                          </td>
                          <td>
                            <span className='text-gray-900 fw-bold text-hover-primary mb-1 fs-6'>
                              ({index + 1}) {item.pileCode}
                            </span>
                            <span className='fw-semibold d-block fs-7'>{item.pileTitle}</span>
                            <span className='text-muted fw-semibold d-block fs-7'>
                              เครื่องจักรที่ใช้ตอก:{' '}
                              {projectMachineOptions.find(pm => pm.value === item.projectMachineId)
                                ?.label ?? '-'}
                            </span>
                            <span className='text-muted fw-semibold d-block fs-7'>
                              Pile No.: {item?.pileNo}
                            </span>
                            <span className='text-muted fw-semibold d-block fs-7'>
                              Grid Line: {item?.gridLine}
                            </span>
                            <span className='text-muted fw-semibold d-block fs-7'>
                              สถานที่: {item?.location}
                            </span>

                            <button
                              className={clsx('btn btn-primary btn-sm mt-3', {
                                'd-none': !showAddButtonAttachmentDrivedPile(index),
                              })}
                              onClick={() => handleExecutedPileAttachment(index)}>
                              <KTSVG
                                path='/media/icons/duotune/general/gen005.svg'
                                className='svg-icon-1x svg-primary'
                              />
                              แนบรูปภาพรอยเชื่อมของเสา ({index}) + ({index + 1})
                            </button>
                          </td>

                          <td className='text-end'>
                            <span className='text-muted fw-semibold'>
                              {moment(item.usedAt).format('YYYY-MM-DD HH:mm')}
                            </span>
                          </td>
                          <td className='text-end'>
                            <a
                              onClick={() => {
                                handleRemoveScanned(item.inventoryCode, item.pileCode)
                              }}
                              href='#'
                              className=''>
                              <KTSVG
                                path='/media/icons/duotune/general/gen040.svg'
                                className='svg-icon-1 svg-icon-2hx svg-icon-danger'
                              />
                            </a>
                          </td>
                        </tr>
                      ))}
                    </tbody>
                    {/* end::Table body */}
                  </table>
                  {/* end::Table */}
                  {pileHole.status === 'in-progress' && (
                    <div className='text-center'>
                      <a
                        onClick={() => {
                          handlePileClose()
                        }}
                        className='btn btn-primary'>
                        <span className='svg-icon svg-icon-1'>
                          <KTSVG
                            path='/media/icons/duotune/general/gen003.svg'
                            className='svg-icon-1  svg-icon-primary'
                          />
                        </span>
                        ปิดหลุม
                      </a>
                    </div>
                  )}
                </div>
              </div>
            </div>
          </div>
        )}
        <div className='text-center'>
          <Link to={'/project/' + projectId + '/overview'}>
            <Button variant='info'>กลับไปโครงการ</Button>
          </Link>
        </div>
      </div>
    </React.Fragment>
  )
}

export default ProjectPileExecutionView
